<div class="one-month-free-checkout-demo">
  @if (!singlePlanMode) {
    <div class="back-wrap" (click)="onBack.emit()">
      <i class="db-icon db-icon-ds-arrow-sharp"></i>
      <span>Back</span>
    </div>
    @if (!!isPaid) {
      <h2 class="mb8">Upgrade to 10Web Pro</h2>
    } @else {
      <h2 class="{{hasCampaignCoupon && couponDays == 7? 'mb24' : 'mb12'}}">
        <ng-container *ngIf="!!hasCampaignCoupon; else noCoupon">
          Get
          <ng-container *ngIf="(couponDays) > 7">
            <span class="db-days-lined">7 days</span>
          </ng-container>

          {{ couponDays == 30 ? '1 month ' : couponDays + ' days' }} of 10Web Pro<br *ngIf="couponDays > 7"/> for free

          <ng-container *ngIf="!!couponPercent">
            &<br *ngIf="couponDays == 7"/>
            enjoy
            <span [ngClass]="{invisible: !couponPercent}" class="coupon-discount">
      {{ couponPercent }}% off
    </span> for your<br *ngIf="couponDays > 7"/> first payment.
          </ng-container>

        </ng-container>

        <ng-template #noCoupon>
          Try 10Web Pro plans {{
            (chosenPlan?.category === UserSubscriptionCategory.DedicatedVM) ? '' :
              ' for Free'
          }}
        </ng-template>
      </h2>
    }
    <p class="db-desc mb24" *ngIf="paidDesc" [innerHTML]="paidDesc"></p>
  }
  <ul class="db-checklist" *ngIf="!paidDesc && chosenPlan?.category !== UserSubscriptionCategory.DedicatedVM">
    <li *ngFor="let point of points">
      <i class="db-icon db-icon-ds-checkmark-sharp"></i>
      <p class="db-checkout-points"
         [innerHTML]="point.replace('%7%', couponDays == 30 ? '1 month' : couponDays.toString() + ' days')"></p>
    </li>
  </ul>

  <div class="one-month-free-plans__payment-wrap">
    @if (singlePlanMode) {
      <div class="db-single-mode-payement">
        <db-payment-info (onClose)="onClose.emit($event)"
                         (onLoading)="loading = $event"
                         (paymentIsPaypal)="handlePaymentIsPaypal($event)"
                         [chosenPlan]="chosenPlan?.price"
                         [coupon]="coupon"
                         [demoUser]="demoUser"
                         [currentSubscription]="userSubscription"
                         [feature]="isPaid? 'ssh': null"
                         [invited]="isInvited"
                         [isPaypalInvalidCode]="payPalInvalidCoupons.includes(couponCodeInput?.value)"
                         [newPrice]="newPrice"
                         [subscription]="chosenPlan"
                         [user]="user"
                         [forDemo]="true"></db-payment-info>
        <div class="one-month-free-plans__payment-due-wrap-container">
          <div class="one-month-free-plans__payment-due-wrap">
            <div (click)="couponSectionToggled = true"
                 *ngIf="!couponSectionToggled" class="db-one-month-free-plans__coupon-link">
              <span>Have a promo code?</span>
            </div>
            <div *ngIf="couponSectionToggled" class="coupon-input-wrap">
                      <span
                        *ngIf="couponCodeInput?.invalid || (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)"
                        [innerHTML]="((payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal) ? 'text_invalidPaypalCouponCodeError' : 'text_checkout_coupon_server_error') | dbText"
                        class="ds-input-error-msg">
                                </span>
              <div *ngIf="!coupon || !coupon?.couponCode || coupon?.couponCode === '1wf'"
                   class="db-one-month-free-plans__coupon-wrap">
                <div [ngClass]="{'with-error': (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)}"
                     class="ds-input-wrap">
                  <div class="button-input-wrapper">
                    <input [formControl]="couponCodeInput"
                           [ngClass]="{'error': couponCodeInput?.invalid || (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)}"
                           class="ds-input" placeholder="Coupon code" type="text">
                    <button (click)="applyCoupon()"
                            [ngClass]="{'ds-btn-disabled': (couponLoading || !couponCodeInput?.value || !!isPaypal)}"
                            class="ds-btn ds-btn-xs">
                      <span *ngIf="!couponLoading">Apply</span>
                      <db-loading-circular-spinner *ngIf="couponLoading"
                                                   color="dark"></db-loading-circular-spinner>
                    </button>
                  </div>

                  <i (click)="deleteCoupon(false)" *ngIf="couponCodeInput?.value"
                     class="db-icon db-icon-ds-close delete-coupon"></i>

                </div>
              </div>
              <p *ngIf="coupon?.couponCode && coupon?.couponCode !== '1wf'" class="promo-code">
                <span>{{ coupon?.couponCode }}</span>
                <span class="icons-wrap">
                                                        <i (click)="deleteCoupon(!couponCodeInput?.invalid)"
                                                           class="db-icon db-icon-ds-close-sharp"
                                                           *ngIf="!couponLoading"></i>
                          <db-loading-circular-spinner *ngIf="couponLoading" color="dark"
                                                       class="mr9"></db-loading-circular-spinner>
                          </span>

              </p>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <db-payment-info (onClose)="onClose.emit($event)"
                       (onLoading)="loading = $event"
                       (paymentIsPaypal)="handlePaymentIsPaypal($event)"
                       [chosenPlan]="chosenPlan?.price"
                       [demoUser]="demoUser"
                       [coupon]="coupon"
                       [currentSubscription]="userSubscription"
                       [feature]="isPaid? 'ssh': null"
                       [invited]="isInvited"
                       [isPaypalInvalidCode]="payPalInvalidCoupons.includes(couponCodeInput?.value)"
                       [newPrice]="newPrice"
                       [subscription]="chosenPlan"
                       [user]="user"
                       [forDemo]="true"></db-payment-info>
    }

    <div class="one-month-free-plans__payment-due-wrap-container">
      <div class="one-month-free-plans__payment-due-wrap">
        <div (click)="couponSectionToggled = true"
             *ngIf="!couponSectionToggled && !singlePlanMode" class="db-one-month-free-plans__coupon-link">
          <span>Have a promo code?</span>
        </div>
        <div *ngIf="couponSectionToggled && !singlePlanMode" class="coupon-input-wrap">
                      <span
                        *ngIf="couponCodeInput?.invalid || (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)"
                        [innerHTML]="((payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal) ? 'text_invalidPaypalCouponCodeError' : 'text_checkout_coupon_server_error') | dbText"
                        class="ds-input-error-msg">
                                </span>
          <div *ngIf="!coupon || !coupon?.couponCode || coupon?.couponCode === '1wf'"
               class="db-one-month-free-plans__coupon-wrap">
            <div [ngClass]="{'with-error': (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)}"
                 class="ds-input-wrap">
              <div class="button-input-wrapper">
                <input [formControl]="couponCodeInput"
                       [ngClass]="{'error': couponCodeInput?.invalid || (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)}"
                       class="ds-input" placeholder="Coupon code" type="text">
                <button (click)="applyCoupon()"
                        [ngClass]="{'ds-btn-disabled': (couponLoading || !couponCodeInput?.value || !!isPaypal)}"
                        class="ds-btn ds-btn-xs">
                  <span *ngIf="!couponLoading">Apply</span>
                  <db-loading-circular-spinner *ngIf="couponLoading"
                                               color="dark"></db-loading-circular-spinner>
                </button>
              </div>

              <i (click)="deleteCoupon(false)" *ngIf="couponCodeInput?.value"
                 class="db-icon db-icon-ds-close delete-coupon"></i>

            </div>
          </div>
          <p *ngIf="coupon?.couponCode && coupon?.couponCode !== '1wf'" class="promo-code">
            <span>{{ coupon?.couponCode }}</span>
            <span class="icons-wrap">
                                                        <i (click)="deleteCoupon(!couponCodeInput?.invalid)"
                                                           class="db-icon db-icon-ds-close-sharp"
                                                           *ngIf="!couponLoading"></i>
                          <db-loading-circular-spinner *ngIf="couponLoading" color="dark"
                                                       class="mr9"></db-loading-circular-spinner>
                          </span>

          </p>
        </div>
        <div class="one-month-free-plans__payment-due-container"
             [ngClass]="{'single-mode': singlePlanMode,  'has-new-price': !couponLoading && singlePlanMode}">
          <div [ngClass]="{fadein: !couponLoading && !singlePlanMode}" class="due-today-demo">
            <p>
              Due today<span
              [innerHTML]="(mode === 'ssh' || !coupon?.freeDaysBeforePayment) ? ''
              : ' (' + (coupon?.freeDaysBeforePayment == 30 ? '1 month' : coupon?.freeDaysBeforePayment + ' days' ) + '  free)'"></span>
            </p>
            <b>${{ coupon?.freeDaysBeforePayment ? '0' : chosenPlan?.price - newPrice }}</b>
          </div>
          <p
            [ngClass]="{fadein: !couponLoading && !singlePlanMode}"
            class="a db-one-month-free-checkout-demo__then-pay">
            Your next payment of
            <span *ngIf="newPrice !== chosenPlan?.price"
                  [ngClass]="{'discounted': !!newPrice, 'annual': !!newPrice && chosenPlan?.periodNumber === 12}">
          ${{ chosenPlan?.price }}</span>
            <span class="db-new-price" *ngIf="newPrice">${{ newPrice | DbNumberFormatPipe: 'precise' }}</span>
            will be charged on {{ expirationDate | date: 'MMM d, y' }}, followed
            by {{ chosenPlan?.type === 'month' ? 'monthly' : 'annual' }} payments of ${{ chosenPlan?.price }}.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="text-center buttons-wrap">
  <button (click)="changeSubscrId();
  paymentInfo.checkoutHandler(coupon)" [ngClass]="{'ds-btn-disabled': loading}" class="ds-btn-black ds-btn-max">
    <span
      *ngIf="!loading">
      @if (isPaid || chosenPlan?.category === UserSubscriptionCategory.DedicatedVM) {
        {{'text_proceed' | dbText }}
      } @else {
          {{'text_try10WebForFree' | dbText }} {{ couponDays == 30 ? '1 Month' : couponDays + ' Days' }}
      }
      </span>
    <db-loading-circular-spinner *ngIf="loading" [color]="'white'"></db-loading-circular-spinner>
  </button>
</div>
